import React from "react";
import { Link, withRouter } from "react-router-dom";
import defaultThumb from "assets/img/defaults/default-thumbnail.jpg";
import Modal from "../../shared/Modal";
import { getDate } from "../../helpers/utilities";

const MapYUV = props => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        //fade: true
    };

    let video_url = <div class="alert alert-info" role="alert">No available updates.</div>
    let has_video = 0
    let updated_date = ''
    let content = <div class="alert alert-info" role="alert">No available updates.</div>
    if (props.items !== undefined && props.items.length > 0) {
        
        props.items.map((item, index) => {
            if(has_video){
                return
            }

            if(item.update_type == 'YUV' && item.video){
                has_video++;
                video_url = <><div style={{display: 'flex', justifyContent: 'center'}}><iframe src={item.video} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen style={{width: '100%', aspectRatio: '16/9'}}></iframe></div>
                    <center><h4>As of {getDate(item.update_date)}</h4></center>
                </>
            }
        });

        return video_url
        //return content
    }
    else{
        return content;
    }
};

export default withRouter(MapYUV);
